export default __webpack_public_path__ + "static/media/got-you-cupboard.09c9e863.png";